import LeadershipProfile from "../../components/LeadershipProfile"
import SEO from "../../components/SEO";

export default function CorporateAdvisors() {
  const corporateAdvisorsSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Corporate Advisors",
    "url": "https://www.thrombio.com.au/leadership/corporate-advisors",
    "mainEntity": {
      "@type": "Organization",
      "name": "Thrombio",
      "url": "https://www.thrombio.com.au/",
      "logo": "https://www.thrombio.com.au/thromBioInvert.png",
      "contactPoint": {
        "@type": "ContactPoint",
        "email": "info@thrombio.com.au"
      },
      "sameAs": [
        "https://www.linkedin.com/company/thrombioholdings"
      ]
    },
    "about": {
      "@type": "Organization",
      "name": "Thrombio",
      "description": "Thrombio is a drug discovery company dedicated to advancing the global standard of care for the treatment of stroke using novel anti-thrombotic drugs with unprecedented safety and efficacy."
    }
  };

  return (
    <div style={{background: "var(--010C0E, #010C0E)"}}>
      <SEO
        title="Corporate Advisors"
        description="Learn about our team of international leaders in stroke clinical trials, scientists with extensive drug development experience and businesspeople with more than 30 years' experience"
        keywords={['Corporate Advisors', 'Rod Jackson', 'Mithran Doraisamy', 'Business Strategy', 'Executive Coaching']}
        ogImage="/rodJackson.webp"
        schema={corporateAdvisorsSchema}
      />

      <div className="corporateAdvisorsBg">
        <div className="px-12 pt-40 md:pt-[150px] xl:pt-[186px] xl:page-width xl:px-0">
          <div className="flex flex-col gap-4 md:gap-16">
            {/* Optimized H1 tag that preserves layout */}
            <div className="text-[4.8rem] font-bold leading-[5.2rem] tracking-[.19rem] drop-shadow-[0_4px_8.9px_#000]">
              <h1 className="sr-only">ThromBio Corporate Advisors: Leading Experts in Biotech and Stroke Therapy</h1>
              Leadership
            </div>
            {/* Optimized H2 tag that preserves layout */}
            <div className="drop-shadow-[0_4px_8.9px_#000] font-syne text-[3rem] font-bold leading-[3.6rem] tracking-[.15rem]">
              <h2 className="sr-only">Our Advisory Board: Pioneers in Stroke Treatment</h2>
              Corporate Advisors
            </div>
          </div>
        </div>
	    <div className="pt-[130px] xl:pt-[90px] xl:pb-[320px] px-16 xl:px-[228px] 2xl:px-[450px] flex flex-col xl:grid grid-cols-2 items-center xl:items-start xl:justify-evenly gap-[115px] md:gap-[75px] corporateAdvisorsBg2">
          <div>
            {/* No visible title but using sr-only for SEO */}
            <LeadershipProfile
              name="Rod Jackson"
              title={<span className="sr-only">Senior Advisor - Financial Services and Business Leadership Expert</span>}
              description="Rod is non-executive director on a range of businesses both domestically and internationally. Rod is Chair of Westpac Europe Ltd based in London and Adviser to Executive Global Network in Singapore. Domestically, Rod is a Director of Newcastle Greater Mutual Group, Director of NextSense, Director of Financial Services Institute of Australasia, Director of Searson Buck Group and Chair of the ODEO Group. He has been a director in financial services, recruitment, property management and e-commerce for 15 years.
Rod has worked as an executive in financial services, primarily at Westpac Banking Corporation, for over 40 years. 11 of which have been in Asia and Europe. For the last twenty years Rod has been either a CFO or COO across numerous roles including Westpac Retail and Business Bank and the St George Banking Group. Rod retired from executive life in January 2021 from the CFO, Westpac Institutional Bank role.
Rod holds a Bachelor of Economics (with specialisation in Accounting) from ANU, Canberra, Australia and an MBA from the International Institute for Management Development in Lausanne, Switzerland."
              image="/rodJackson.webp"
            />
          </div>
          <img src="/1.2.svg" alt="Decorative divider" width={23} height={14} className="xl:hidden" />
          <div className="">
            {/* No visible title but using sr-only for SEO */}
            <LeadershipProfile
              name="Mithran Doraisamy"
              title={<span className="sr-only">Strategic Consultant - Expert in Business Growth and Transformation</span>}
              description="Mithran is a non-executive director and an executive coach, mentor and advisor. 
He has had senior roles in large organisations across an executive and consulting career focused on driving business growth and transformation across multiple industries. He has been a Senior Partner at Korn Ferry, a Senior Partner at Partners in Performance (now part of Accenture), a senior executive at Telstra driving productivity and strategy, and a Managing Partner of Customer and Transformation at EY, a practice that he also co-founded. He recently retired from full-time executive life. 
Mithran has a Bachelor of Science (Computer Science and Accounting) from Monash University, an MBA from the Melbourne Business School and numerous professional certificates across a range of disciplines e.g. cybersecurity, energy transition, digital transformation and innovation. He is a Fellow of Chartered Accountants ANZ (FCA) and a Fellow of the Australian Institute of Company Directors (FAICD)."
              image="/mithranDoraisamy.webp"
            />
          </div>
        </div>
      </div>
    </div>
  );
}